import { useGetCarrierConnectCompanyAndUserTenantRelationshipsQuery } from '@connect-carrier/generated/queries/getCarrierConnectCompanyAndUserTenantRelationships';
import { getLocalStorage, setLocalStorage } from '@utils/localStorage';
import { useEffect, useMemo } from 'react';

type Shape = Maybe<{ id: string; name: string }>;

const initialCompanyInfo = getLocalStorage<Shape>('companyInfo');

export const useCompanyInfo = (): Maybe<{
  id?: string;
  name?: string;
  error?: string;
}> => {
  const { data, error } =
    useGetCarrierConnectCompanyAndUserTenantRelationshipsQuery({
      variables: {
        startIndex: 0,
        pageSize: 100,
        endIndex: 100,
      },
      skip: Boolean(initialCompanyInfo),
    });
  const obj = data?.getCarrierConnectCompanyAndUserTenantRelationships?.company;

  const saveObj = useMemo(() => {
    if (obj?.companyId && obj.companyName) {
      return { id: obj.companyId, name: obj.companyName };
    }
    return undefined;
  }, [obj?.companyId, obj?.companyName]);

  useEffect(() => {
    const existing = getLocalStorage<Shape>('companyInfo');
    if (
      saveObj &&
      (!existing ||
        existing.id !== saveObj.id ||
        existing.name !== saveObj.name)
    ) {
      setLocalStorage('companyInfo', saveObj);
    }
  }, [saveObj]);

  if (
    error ||
    (data && !data?.getCarrierConnectCompanyAndUserTenantRelationships.company)
  ) {
    return {
      error: 'There was an issue fetching your company data. Please try again.',
    };
  }

  return saveObj ?? initialCompanyInfo;
};
